import React from 'react';

import PipelineTagsTableContext from 'app/settings/tags-page/context/PipelineTagsTableContext';
import PipelineTagModal from './PipelineTagModal/PipelineTagModal';
import PipelineTagsTable from './PipelineTagsTable';

export default function PipelineTagsPane() {
  return (
    <PipelineTagsTableContext>
      <PipelineTagModal />
      <PipelineTagsTable />
    </PipelineTagsTableContext>
  );
}
